import {LogLevel} from "@azure/msal-browser";
import {PublicClientApplication} from "@azure/msal-browser";

const clientId = process.env.REACT_APP_AZURE_SSO_CLIENT_ID;
const tenantId = process.env.REACT_APP_AZURE_SSO_TENANT_ID;
const applicationIdUrl = process.env.REACT_APP_AZURE_SSO_APPLICATION_ID_URL;

console.log("window.location.origin = ${window.location.origin} " + window.location.origin);
export const msalConfig = {
    auth: {
        clientId: clientId, // front client ID
        authority: "https://login.microsoftonline.com/" + tenantId,
        redirectUri: `${window.location.origin}/auth/callback/`
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return;
                console.log(message);
            },
            logLevel: LogLevel.Info
        }
    }
};

export const loginRequest = {
    // scopes: ["User.Read", "openid", "profile"]
    scopes: ["openid", "profile", "offline_access"]
};

export const apiRequest = {
    scopes: [applicationIdUrl]
};

// PublicClientApplication instance
export const pca = new PublicClientApplication(msalConfig);